import { Button, Stack, Typography } from "@mui/material";
import Frame from "../Frames/Basic";
import { Link } from "react-router-dom";
import { txt } from "../../services/translation";

export default function Auth(){

    return (
        <Frame center>
            <Stack spacing={3} sx={{maxWidth: 400, margin: 'auto'}} alignItems='flex-start'>
    
                <Typography variant='h1'>{txt('welcomeToLearnyLib')}</Typography>
    
                <Typography>{txt('noLearnyLibAccountPrompt')}</Typography>
    
                <Button variant='contained' component={Link} to='/register' sx={{width: 150}}>
                    {txt('signUp')}
                </Button>
    
                <Typography>{txt('alreadyLearnyLibMember')}</Typography>
    
                <Button variant='outlined' component={Link} to='/' sx={{width: 150}}>
                    {txt('signIn')}
                </Button>
    
            </Stack>
        </Frame>
    );
    
}